import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, of, filter, combineLatest } from 'rxjs';
import { catchError, map,take, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean {
    debugger
    console.log('AuthGuard:', state.url);
    //const isLoggedIn = this.authService.isLoggedIn();

    return this.authService.isAuthenticated$.pipe(
      take(1),
      switchMap(isAuthenticated => {

        if (!isAuthenticated) {
          return of(this.router.createUrlTree(['/login'], {
            queryParams: { returnUrl: state.url }
          }));
        }

        if (this.shouldRefreshToken()) {
          return this.authService.refreshAccessToken().pipe(
            map(() => true),
            catchError(() => of(this.router.createUrlTree(['/login'])))
          );
        }

        return of(true);
      })
    );

    // Uncomment this block once we use authReady$ to ensure auth state is initialized before checking
    //return combineLatest([
    //  this.authService.isAuthenticated$,
    //  this.authService.authReady$
    //]).pipe(
    //  filter(([_, ready]) => ready),
    //  take(1),
    //  map(([isAuthenticated]) => {
    //    return isAuthenticated
    //      ? true
    //      : this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    //  })
    //);
  }

  /**
   * Determine if token should be refreshed
   * Refresh if token expiry is within 80% threshold
   */
  private shouldRefreshToken(): boolean {
    const expiryTime = localStorage.getItem('tokenExpiry');
    if (!expiryTime) return false;

    const expiryMs = parseInt(expiryTime, 10);
    const now = Date.now();
    const timeUntilExpiry = expiryMs - now;
    const accessTokenLifetime = 15 * 60 * 1000; // 15 minutes in ms

    // Refresh if token is 80% through its lifetime
    const refreshThreshold = accessTokenLifetime * 0.80;
    const tokenAge = accessTokenLifetime - timeUntilExpiry;

    return tokenAge > refreshThreshold;
  }
}
